import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import Tracker from '../../domain/tracker/Tracker';
import TrackerSchema from '../../domain/tracker/TrackerSchema';
import { TrackerActions } from '../actions/TrackerActions';

export interface TrackerState {
  tracker: Tracker;
  trackerSchema: DeploymentModel<TrackerSchema> | null;
  isUpdate: boolean;
  isDirty: boolean;
}

const initialState: TrackerState = {
  tracker: ValueFactory.initializeTracker(),
  trackerSchema: { stage: 'DRAFT' } as DeploymentModel<TrackerSchema>,
  isUpdate: false,
  isDirty: false,
};

export const trackerReducer = (state = initialState, action: ReduxBaseAction<any, TrackerActions>): TrackerState => {
  switch (action.type) {
    case 'CHANGE_TRACKER':
      return { ...state, tracker: action.payload, isDirty: true };
    case 'CHANGE_TRACKER_SCHEMA':
      return { ...state, trackerSchema: action.payload };
    case 'CHANGE_TRACKER_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_TRACKER':
      return { ...state, tracker: ValueFactory.initializeTracker(), isUpdate: false, trackerSchema: null, isDirty: false };
    case 'CHANGE_TRACKER_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
